exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.progress[data-v-00c1e3b7] {\n    text-align: center;\n}\n.sizes[data-v-00c1e3b7] {\n    text-align: right; \n    padding-top: 0\n}\n", ""]);

